import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeAuthorisedProduct } from "../Entity/TreeNodeAuthorisedProduct";
import { TreeNodeDevelopmentProduct } from "../Entity/TreeNodeDevelopmentProduct";
import { TreeNodeAuthorisedPharmaceuticalFormList } from "./TreeNodeAuthorisedPharmaceuticalFormList";
import { TreeNodeDrugsATCList } from "./TreeNodeDrugsATCList";
import { TreeNodeDrugsIndicationsList } from "./TreeNodeDrugsIndicationsList";
import { TreeNodeMedicinalProductTypeList } from "./TreeNodeMedicinalProductTypeList";
import { TreeNodePharmaceuticalProductsList } from "./TreeNodePharmaceuticalProductsList";
import { TreeNodePreviousEVCodeList } from "./TreeNodePreviousEVCodeList";
import { TreeNodeProductAttachmentList } from "./TreeNodeProductAttachmentList";
import { Art57Section } from "../../../Art57Section/Art57Section";

export class TreeNodeProductsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Products ({param})');
      this.parent = parent;
      this.labelNodeName = 'Products';      
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let nodeCreated: any;
      
      const authorisedRequestedNode: boolean =
        params.nodeTypeToCreateName == 'addAuthorisedProduct';
  
      if (authorisedRequestedNode) {

        let authorisedProductNode = new TreeNodeAuthorisedProduct(this.ioc!, this);
        if ((params.operationType === 1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) { // only operationtype insert has localnumber
          authorisedProductNode.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber(); 
        }

        authorisedProductNode.expanded = true;
    
        let authorisedProductNodes: Art57Node[] = [];
    
        authorisedProductNodes.push(
          new TreeNodeMedicinalProductTypeList(this.ioc!, authorisedProductNode)
        );
        authorisedProductNodes.push(
          new TreeNodeAuthorisedPharmaceuticalFormList(this.ioc!, authorisedProductNode)
        );
        authorisedProductNodes.push(
          new TreeNodePharmaceuticalProductsList(this.ioc!, authorisedProductNode)
        );
        authorisedProductNodes.push(new TreeNodeDrugsATCList(this.ioc!, authorisedProductNode));
        authorisedProductNodes.push(
          new TreeNodeDrugsIndicationsList(this.ioc!, authorisedProductNode)
        );
        authorisedProductNodes.push(
          new TreeNodePreviousEVCodeList(this.ioc!, authorisedProductNode)
        );
        authorisedProductNodes.push(
          new TreeNodeProductAttachmentList(this.ioc!, authorisedProductNode)
        );
    
        authorisedProductNodes.map((nodeToAdd) => {
          authorisedProductNode.children?.push(nodeToAdd);
        });
    
        this.refreshLabel();
        nodeCreated = [authorisedProductNode];

      } else {


        let developmentProductNode: Art57Node = new TreeNodeDevelopmentProduct(this.ioc!, this);
        if ((params.operationType === 1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) { // only operationtype insert has localnumber
          developmentProductNode.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber(); 
        }

        developmentProductNode.expanded = true;
        let developmentProductNodes: Art57Node[] = [];

        if ((params.operationType === 1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) { // only operationtype insert has localnumber
          developmentProductNode.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber(); 
        }
    
        developmentProductNodes.push(new TreeNodePharmaceuticalProductsList(this.ioc!, developmentProductNode));
        developmentProductNodes.push(new TreeNodeDrugsATCList(this.ioc!, developmentProductNode));
        developmentProductNodes.push(new TreeNodeDrugsIndicationsList(this.ioc!, developmentProductNode));
        developmentProductNodes.push(new TreeNodeProductAttachmentList(this.ioc!, developmentProductNode));
    
        developmentProductNodes.map((nodeToAdd) => {
          developmentProductNode.children?.push(nodeToAdd);
        });
    
        this.refreshLabel();
    
        nodeCreated = [developmentProductNode];

      }
  
      if (nodeCreated) {
        this.children?.push(nodeCreated[0]);
      }
  
      this.refreshLabel();
      return nodeCreated;

    }
  
    override getMessage(): any {
      let message = {};
      let authorisedproducts: any[] = [];
      let developmentproducts: any[] = [];
  
      this.children?.forEach((node) => {
        let art57Node = node as Art57Node;
        let art57Message = art57Node.getMessage();
        if (art57Message != null) {
          if (art57Node instanceof TreeNodeAuthorisedProduct) {
            authorisedproducts.push(art57Message);
          } else if (art57Node instanceof TreeNodeDevelopmentProduct) {
            developmentproducts.push(art57Message);
          }
        }
      });
  
      let authoriseProductsMessage = null;
      if (authorisedproducts.length > 0) {
        authoriseProductsMessage = {
          authorisedproducts: { authorisedproduct: authorisedproducts },
        };
        message = { ...message, ...authoriseProductsMessage };
      }
  
      let developmentProductsMessage = null;
      if (developmentproducts.length > 0) {
        developmentProductsMessage = {
          developmentproducts: { developmentproduct: developmentproducts },
        };
        message = { ...message, ...developmentProductsMessage };
      }
  
      return { ...message };
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Operation Type', 'Type', 'Product Name'];
    }
  }